const proximityAgenciesRadius =
  process.env.NEXT_PUBLIC_PROXIMITY_AGENCIES_RADIUS ?? "";
const maxProximityAgencies =
  process.env.NEXT_PUBLIC_MAX_PROXIMITY_AGENCIES ?? "";

export const apiRoutes = {
  fetchDisponibilities: (queryParams: string) =>
    `/agencies/v1/disponibilities?${queryParams}`,
  fetchAgencyInformation: (agencyId: string) =>
    `/agencies/v1/${agencyId}?radius=${proximityAgenciesRadius}&maxProximityAgency=${maxProximityAgencies}`,
};
